import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './assets/css/iconfont/iconfont.css';
import './components/common/directives';
import 'babel-polyfill';
// import VideoPlayer from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'

import '@/assets/css/varLess.less'

import VueParticles from 'vue-particles'

import outToExcel from './utils/outToExcel'
Vue.prototype.outToExcels = outToExcel;

Vue.config.productionTip = false;
import store from './store'
Vue.use(VueParticles)

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
import RemFit from 'rem-fit'

import * as echarts from "echarts"
Vue.prototype.$echarts = echarts

// 获取用户配置信息
// import userConfig from './utils/userConfig'
// userConfig.setConfig()

const params = [
  //屏幕宽度>=0px时屏幕rem宽度为7.5rem
  {
    breakpoint: 0,
    proportion: 7.5
  },
  //屏幕宽度>=640px时屏幕rem宽度为20rem
  {
    breakpoint: 640,
    proportion: 20
  },
  //屏幕宽度>=1280px时屏幕rem宽度为28rem
  {
    breakpoint: 1280,
    proportion: 38
  },
  //屏幕宽度>=1920px时屏幕rem宽度为40rem
  {
    breakpoint: 1920,
    proportion: 40
  }
]

const remFit = new RemFit(params, false)
remFit.init()

Vue.use(dataV)
// Vue.use(VideoPlayer)

Vue.use(VueI18n);
Vue.use(ElementUI, {
  size: 'small'
});
const i18n = new VueI18n({
  locale: 'zh',
  messages
});

function debounce(fn, delay) {
  var t = null;
  return function () {
    if (t) {
      clearTimeout(t);
    }
    t = setTimeout(fn, delay);
  };
}
function sizeChange() {
  if (!store.state.setting.systemForm.renderWindow) {
    return
  } else {
    ElementUI.MessageBox({
      title: '提示',
      message: '检测到您的浏览器大小发生改变，是否刷新界面',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      showCancelButton: true,
      type: 'warning'
    }).then(() => {
      router.push({ path: '/None' });
    }).catch(() => { });
  }

}

// window.addEventListener('resize', debounce(sizeChange, 1000));


//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  console.log(to, from);
  let role = ''
  if (to.query && to.query.token) {
    role = JSON.parse(to.query.companyInfo);
  } else {
    role = JSON.parse(localStorage.getItem('companyInfo'));
  }
  console.log(role);
  if (!role && to.path !== '/login') {
    next('/login');
  } else if (to.meta.permission) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    role.companyId === 1 ? next() : next('/403');
  } else {
    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
      Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
        confirmButtonText: '确定'
      });
    } else {
      next();
    }
  }
});

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
